import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";
import { getNodeFileGroups } from "api/services/node-service";
import { useCallback } from "react";
import { IGetNodeFileGroupsRequest } from "api/models/request/IGetNodeFileGroupsRequest";
import { ResourceType } from "@models/ResourceType";

export const useGetNodeFileGroups = () => {
    const {
        callAPI,
        loading
    } = useWorkspaceApiCall<IGetNodeFileGroupsRequest, string[]>(getNodeFileGroups, '', 'getNodeFileGroups.error');

    const fetchNodeFileGroups = useCallback(async (editor: any, resourceType: ResourceType) => {
        const response = await callAPI({ resourceType: resourceType });

        if (response?.success) {
            editor.storage.setNodeFileGroups(resourceType, response.data);
        }

        return response;
    }, [callAPI])

    return { fetchNodeFileGroups, isLoading: loading };
}